/**
 * Constantes de roles - única fuente de verdad para IDs y nombres.
 * Debe estar alineado con el backend y con resources/users.js (choices).
 */
export const ROLE_IDS = {
  NO_ROLE: 0,
  ADMIN: 1,
  MANAGER: 2,
  RENTAL_MANAGER: 3,
  TOUR_MANAGER: 4,
  BASE_MANAGER: 5,
  FINANCIAL: 6,
  AGENT: 7,
  RESERVATIONS: 8,
  SUPER_ADMIN: 9,
};

/** Lista de roles para selects y listados (id + name) */
export const ROLES = [
  { id: ROLE_IDS.NO_ROLE, name: 'No role' },
  { id: ROLE_IDS.ADMIN, name: 'Admin' },
  { id: ROLE_IDS.MANAGER, name: 'Manager' },
  { id: ROLE_IDS.RENTAL_MANAGER, name: 'Rental Manager' },
  { id: ROLE_IDS.TOUR_MANAGER, name: 'Tour Manager' },
  { id: ROLE_IDS.BASE_MANAGER, name: 'Base Manager' },
  { id: ROLE_IDS.FINANCIAL, name: 'Financial' },
  { id: ROLE_IDS.AGENT, name: 'Agent' },
  { id: ROLE_IDS.RESERVATIONS, name: 'Reservations' },
  { id: ROLE_IDS.SUPER_ADMIN, name: 'Super Admin' },
];



// WEBPACK FOOTER //
// ./src/rbac/constants.js